export type ExtremeWindHazardCode = 'tc' | 'wind_gust'

export type ExtremeWindDashboardConfig = {
  hazardCode: ExtremeWindHazardCode
  periodized: boolean
  speedMetricCode: 'wind_speed' | 'gust_speed'
  label: string
  title: string
}

export const extremeWindDashboardConfig: Record<ExtremeWindHazardCode, ExtremeWindDashboardConfig> = {
  tc: {
    hazardCode: 'tc',
    periodized: false,
    speedMetricCode: 'wind_speed',
    label: 'extreme wind from tropical cyclones',
    title: 'Tropical Cyclone Wind',
  },
  wind_gust: {
    hazardCode: 'wind_gust',
    periodized: true,
    speedMetricCode: 'gust_speed',
    label: 'extreme wind gust',
    title: 'Extreme Wind from Gusts',
  },
}
